module.exports = __webpack_public_path__ + "static/media/icon-green.ffeaf82b.svg";